<template>
  <div :class="$style.root">
    <SharedExhibitionsHeaderComponent :page="page" />

    <div :class="$style.closeContainer">
      <i18nLink
        :to="routeObject"
      >
        <CoreButtonsCloseComponent />
      </i18nLink>
    </div>

    <LayoutGridComponent>
      <CoreImageComponent
        v-for="image in images"
        :image="getAttributes(image)"
        :class="$style.image"
        :showCaption="true"
      />
    </LayoutGridComponent>

    <SharedRelatedComponent :page="page" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

const getAttributes = baseStrapiGetAttributes
const page = baseStrapiGetAttributes(props.data)
const images = page?.images?.data

const route = useRoute()
const router = useRouter()
const nuxtApp = useNuxtApp()

const routeObject = { name: 'exhibitions-slug', params: { slug: route?.params?.slug } }
const path = nuxtApp.$localePath(routeObject)

if (!images) {
  router.push(path)
}

</script>

<style module>
.root {
  display: flex;
  flex-direction: column;
  gap: var(--font-default--line-height);

  position: relative;
}

.closeContainer {

  position: sticky;
  top: var(--height--site-nav);
  z-index: 1;
  display: flex;
  padding: 0 var(--unit--default);
}

.image img {
  --base--image--object-fit: contain;
  --base--image--object-position: center;
  --base--image--max-aspect-ratio: 1.5;
}
</style>
